export function isTastingMenuOrderPackage(orderPackage) {
  return String(orderPackage?.package?.type || orderPackage?.packageType || "").toUpperCase() === "TASTING_MENU";
}

export function aggregateSoldRowsByArticle(rows) {
  const articles = new Map();
  (Array.isArray(rows) ? rows : []).forEach((row) => {
    if (row?.articleKind === "PACKAGE") return;
    const label = row?.articleLabel || row?.name;
    if (!label) return;
    articles.set(label, Number(articles.get(label) || 0) + Number(row?.total || 0));
  });
  return [...articles.entries()].sort((a, b) => b[1] - a[1]);
}
